export enum ResponseCode {
  OK = 'OK',
  NOK = 'NOK',
}
